import FundTearSheet from './FundTearSheet'

export default FundTearSheet
